<template>
  <div>
    <a-card title="Meeting Participants" :bordered="false" style="width: auto">
        <button slot="extra"  class="btn btn-primary pull-right btn-sm" @click="showModal">Add +</button></h5>
        <div class="card-body">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Registrants">
                    <table class="table"  v-if="count_registrants">
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Status</th>
                        </tr>
                        <tbody>
                        <tr  v-for="item in registrants" :key="item.id">
                            <td>{{item.first_name}} {{item.last_name}}</td>
                            <td>{{item.email}}</td>
                            <td>{{item.status}} </td>
                        </tr>
                        </tbody>
                    </table>
                      <a-empty v-else>  <span slot="description"> {{registrant_message}} </span></a-empty>
                </a-tab-pane>
                <a-tab-pane key="2" tab="Participants" force-render>
                    <table class="table" v-if="count_participants_after">
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                        </tr>
                        <tbody >
                        <tr v-for="item in participants_after" :key="item.id">
                            <td>{{item.name}} {{item.last_name}}</td>
                            <td>{{item.user_email}}</td>
                        </tr>
                        </tbody>
                    </table>
                        <a-empty v-else>  <span slot="description"> {{participants_message}} </span></a-empty>
                </a-tab-pane>
    
            </a-tabs>
        </div>
        <a-modal
            title="New Registrant"
            :visible="visible"
        >
         <template slot="footer">
            <a-button key="back" @click="handleCancel">
              Cancel
            </a-button>
            <a-button key="submit" type="primary" @click="handleOk">
              Save
            </a-button>
          </template>
        <form>
            <label>First Name:</label> <a-input v-model="participant.first_name"/>
            <label>Last Name:</label> <a-input v-model="participant.last_name" />
            <label>Email:</label> <a-input v-model="participant.email" />
            <label>Adsress:</label> <a-input v-model="participant.address" />
            <label>City:</label> <a-input v-model="participant.city" />
        </form>
        </a-modal>
    </a-card>
  </div>
</template>

<script>
import API from '../../services/api';
export default {
  data() {
    return {
      meeting_id: this.$route.params.id,
      registrants:[],
      visible: false,
      confirmLoading: false,
      count_registrants:false,
      count_participants_after:false,
      participant:{
        email: "",
        first_name: "",
        last_name: "",
        address: "",
        city: ""
      },
      participants:[],
      participants_after:[],
      registrant_message:'No Registrants',
      participants_message:'No participants'
    };
  },
  created() {
    this.getRegistrants()
    this.morenPjes()
  },
  methods: {
    getRegistrants(){
      API.get(`/meetings/${this.meeting_id}/registrants`)
      .then(response => {
        if(response.status === 200){
         
            if(response.data.total_records > 0){
                this.registrants = response.data.registrants
                this.count_registrants = true
              }
        }
        if(response.status === 302){
          this.registrant_message = response.data.message
        }
      })
    },

    async morenPjes(){
       await API.get(`/meetings/${this.meeting_id}/participants`)
       .then(response => {
            if(response.status === 200){
              if(response.data.participants.length > 0){
                  this.count_participants_after = true
                  this.participants_after = response.data.participants
              }
            }
            if(response.status === 302){
              this.participants_message = response.data.message
            }
        })
    },
    notifyVue(verticalAlign, horizontalAlign) {
      const color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        component: NotificationTemplate,
        icon: "ti-gift",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: 'success'
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.participants.push(this.participant)
      API.post(`/meetings/${this.meeting_id}/registrants`,{participants:this.participants})
      .then(({data}) => {
          this.getRegistrants()
      })
      this.onReset()
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
    onReset(){
        this.participants = []
        this.participant = {
            email: "",
            first_name: "",
            last_name: "",
            address: "",
            city: ""
        }
    }
  }
};
</script>